import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { fmtDateTime, fmtRupiah } from "@/lib/format";
import { toast } from "sonner";
import { Check, X, Plus } from "lucide-react";

const STATUS_CLS = { Diajukan: "bg-amber-100 text-amber-800", Disetujui: "bg-emerald-100 text-emerald-800", Ditolak: "bg-red-100 text-red-700" };

export const DealAddendums = ({ deal, projectId, onChanged }) => {
  const [desc, setDesc] = useState("");
  const [amount, setAmount] = useState("");
  const call = async (fn, msg) => {
    try { await fn(); toast.success(msg); onChanged(); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const submit = () => call(async () => {
    await api.post(`/projects/${projectId}/deal/addendums`, { description: desc, amount: Number(amount) });
    setDesc(""); setAmount("");
  }, "Addendum diajukan");
  const review = (aid, decision) => {
    let reason = "";
    if (decision === "reject") { reason = window.prompt("Alasan penolakan addendum (wajib):") || ""; if (!reason) return; }
    call(() => api.post(`/projects/${projectId}/deal/addendums/${aid}/${decision}`, { reason }), decision === "approve" ? "Addendum disetujui" : "Addendum ditolak");
  };

  return (
    <Card className="p-4" data-testid="deal-addendums">
      <h3 className="font-heading font-semibold text-navy text-sm mb-1">Addendum Kontrak</h3>
      <p className="text-xs text-muted-foreground mb-3">Hanya addendum yang disetujui Owner/Manager yang menambah Total Nilai Kontrak.</p>
      {deal.addendums.length === 0 ? <p className="text-sm text-muted-foreground mb-2">Belum ada addendum.</p> : (
        <div className="space-y-2 mb-3">
          {deal.addendums.map((a) => (
            <div key={a.id} className="border rounded-md p-2.5 flex items-center justify-between gap-2 flex-wrap" data-testid={`addendum-${a.no}`}>
              <div>
                <div className="text-sm font-medium"><span className="font-mono-k3 text-primary mr-1.5">{a.no}</span>{a.description}</div>
                <div className="text-xs text-muted-foreground">{fmtDateTime(a.created_at)} · {a.created_by}{a.reviewed_by ? ` · diputuskan ${a.reviewed_by}` : ""}{a.reason ? ` · ${a.reason}` : ""}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-navy text-sm">{fmtRupiah(a.amount)}</span>
                <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${STATUS_CLS[a.status]}`} data-testid={`addendum-status-${a.no}`}>{a.status}</span>
                {deal.can_approve_addendum && a.status === "Diajukan" && (<>
                  <Button size="icon" variant="outline" className="h-7 w-7" onClick={() => review(a.id, "approve")} data-testid={`addendum-approve-${a.no}`}><Check size={14} /></Button>
                  <Button size="icon" variant="outline" className="h-7 w-7" onClick={() => review(a.id, "reject")} data-testid={`addendum-reject-${a.no}`}><X size={14} /></Button>
                </>)}
              </div>
            </div>
          ))}
        </div>
      )}
      {deal.can_addendum && (
        <div className="flex flex-col sm:flex-row gap-2">
          <Input placeholder="Uraian pekerjaan tambahan" value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="addendum-desc-input" />
          <Input type="number" placeholder="Nilai (Rp)" value={amount} onChange={(e) => setAmount(e.target.value)} className="sm:w-44" data-testid="addendum-amount-input" />
          <Button variant="outline" disabled={!desc.trim() || !amount} onClick={submit} data-testid="addendum-submit-btn"><Plus size={14} className="mr-1" />Ajukan</Button>
        </div>
      )}
      {!deal.locked && <p className="text-xs text-muted-foreground">Addendum dapat diajukan setelah Harga Deal dikunci.</p>}
    </Card>
  );
};
